import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { Point } from "pixi.js";
export class BonusHelpLandscapeProperties extends ButtonProperties {
    constructor() {
        super("HelpButton", "Game", new Point(1765, 55));
        this.scale.set(0.7, 0.7);
    }
}
